import { render } from "./SortByBar.vue?vue&type=template&id=70ea5f78&scoped=true"
import script from "./SortByBar.vue?vue&type=script&lang=js"
export * from "./SortByBar.vue?vue&type=script&lang=js"

import "./SortByBar.vue?vue&type=style&index=0&id=70ea5f78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70ea5f78"

export default script